import { get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'


export const findResponsibleStateListRequest = () => ({
    type: type.FIND_STATE_RESPONSIBLE_LIST_REQUEST,
})


export const findResponsibleStateListSuccess = (stateResponsibleList) => ({
    type: type.FIND_STATE_RESPONSIBLE_LIST_SUCCESS,
    payload: {
        stateResponsibleList,
    },
})

export const findResponsibleStateListError = (error) => ({
    type: type.FIND_STATE_RESPONSIBLE_LIST_ERROR,
    payload: {
        error,
    },
})


export const findResponsibleStateList = () => (dispatch, getState) => {
    dispatch(findResponsibleStateListRequest())

    get('/api/process/state-responsible/find-all')
        .then(processInstance => {
            dispatch(findResponsibleStateListSuccess(processInstance))
        })
        .catch(error => {
            dispatch(findResponsibleStateListError(error))
        })
}


export const changeStateResponsible = (stateResponsibleId, name, value) => ({
    type: type.CHANGE_STATE_RESPONSIBLE,
    payload: {
        stateResponsibleId,
        name,
        value,
    },
})


export const saveStateResponsibleRequest = () => ({
    type: type.SAVE_STATE_RESPONSIBLE_REQUEST,
})

export const saveStateResponsibleSuccess = (stateResponsible) => ({
    type: type.SAVE_STATE_RESPONSIBLE_SUCCESS,
    payload: {
        stateResponsible,
    },
})

export const saveStateResponsibleError = (error) => ({
    type: type.SAVE_STATE_RESPONSIBLE_ERROR,
    payload: {
        error,
    },
})

export const saveStateResponsible = (stateResponsibleId) => (dispatch, getState) => {
    const state = getState()
    const stateResponsible = selector.selectStateResponsibleById(state, stateResponsibleId)
    if (!stateResponsible) {
        return
    }

    dispatch(saveStateResponsibleRequest())

    post('/api/process/state-responsible/save', stateResponsible)
        .then(stateResponsible => {
            dispatch(saveStateResponsibleSuccess(stateResponsible))
        })
        .catch(error => {
            dispatch(saveStateResponsibleError(error))
        })
}




// WEBPACK FOOTER //
// ./src/modules/process/state/state-responsible/action.js